import React from 'react';
import { Link } from 'react-router-dom';
import { formatNum, formatTrend } from '../../utils/dashboardFormatters';

const KPI_CONFIG = [
  { key: 'activeUsers', label: 'Active users', icon: 'fa-user-check', accent: '#074f78', bg: '#EFF6FF', to: '/users?onboardingStatus=complete' },
  { key: 'onboardingUsers', label: 'Onboarding progress', icon: 'fa-hourglass-half', accent: '#D97706', bg: '#FEF3C7', to: '/users?onboardingStatus=incomplete' },
  { key: 'totalUsers', label: 'Total users', icon: 'fa-users', accent: '#2563EB', bg: '#DBEAFE', to: '/users?onboardingStatus=' },
  { key: 'paidUsers', label: 'Paid users', icon: 'fa-credit-card', accent: '#7C3AED', bg: '#EDE9FE', to: '/users?plan=__paid__' },
  { key: 'freemiumUsers', label: 'Freemium', icon: 'fa-star', accent: '#10B981', bg: '#D1FAE5', to: '/users?plan=free' },
  { key: 'newUsersToday', label: 'New users (24h)', icon: 'fa-user-plus', accent: '#16A34A', bg: '#DCFCE7', to: '/users?sort=newest', fromToday: true },
  { key: 'trustedCircles', label: 'Trusted circles', icon: 'fa-circle-nodes', accent: '#0891B2', bg: '#CFFAFE', to: '/trusted-circles' },
  { key: 'pendingInvites', label: 'Pending trusted invites', icon: 'fa-clock', accent: '#DC2626', bg: '#FEE2E2', to: '/trusted-circles?status=pending' },
  { key: 'organizations', label: 'Organizations', icon: 'fa-building', accent: '#4F46E5', bg: '#E0E7FF', to: '/organizations' },
  // Phase 2: { key: 'campaignsNeedingAction', label: 'Campaigns to review', icon: 'fa-comment-dots', accent: '#EA580C', bg: '#FFEDD5', to: '/campaign-manager' },
];

export default function DashboardKpiStrip({ metrics, today, trends, loading }) {
  if (loading) {
    return (
      <div className="db-kpi-grid">
        {KPI_CONFIG.map((c) => (
          <div key={c.key} className="db-kpi-skeleton" aria-hidden />
        ))}
      </div>
    );
  }

  const values = {
    ...metrics,
    newUsersToday: today?.newUsersToday,
  };

  const newUsersDelta = trends?.newUsersDelta ?? trends?.activeUsersDelta;
  const trendLabel = formatTrend(newUsersDelta);

  return (
    <div className="db-kpi-grid">
      {KPI_CONFIG.map((cfg) => {
        const val = values[cfg.key];
        const showTrend = cfg.key === 'newUsersToday' && trendLabel;
        return (
          <Link
            key={cfg.key}
            to={cfg.to}
            className="db-kpi-card fade-up"
            style={{ '--db-accent': cfg.accent }}
          >
            <div className="db-kpi-icon" style={{ background: cfg.bg, color: cfg.accent }}>
              <i className={`fas ${cfg.icon}`} />
            </div>
            <div className="db-kpi-body">
              <div className="db-kpi-label">{cfg.label}</div>
              <div className="db-kpi-num">{formatNum(val ?? 0)}</div>
              {showTrend ? (
                <div className={`db-kpi-trend${newUsersDelta < 0 ? ' negative' : ''}`}>
                  {trendLabel}
                </div>
              ) : null}
            </div>
          </Link>
        );
      })}
    </div>
  );
}
